import elementTypes from '../../elements/types';

export function getDefaultOptions(options) {

  const nodeOptions = {
    url: '',
    children: [
      { text: '' }
    ],
    ...options,
    type: elementTypes.LINK
  };

  return nodeOptions;

}

export function buildNode(options) {

  const node = {
    ...getDefaultOptions(options)
  };

  return node;

}

export function buildNodeV2(url) {

  const node = {
    ...buildNode({ url }),
    children: [
      { text: url, bold: true }
    ]
  };

  return node;

}